import axios from "axios";
import { api } from "../config";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

function setAuthorization() {
  const authUserStr = localStorage.getItem("authUser");

  if (!authUserStr) {
    delete axios.defaults.headers.common["Authorization"];
    return;
  }

  try {
    const authUser = JSON.parse(authUserStr);

    if (authUser && authUser.token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser.token}`;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  } catch (error) {
    delete axios.defaults.headers.common["Authorization"];
  }
}


// Set authorization on initial load
setAuthorization();

// Request interceptor
axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    // Backend response structure: { statusCode, status, message, data, ... }
    const responseData = response.data || response;

    // Check if status is 0 (operation failed but API worked)
    if (responseData.status === 0) {
      return Promise.reject(new Error(responseData.message || "Operation failed"));
    }

    // Return the full response data (includes statusCode, status, message, data)
    return responseData;
  },
  function (error) {
    let message;
    if (error.response) {
      // Backend error response structure: { statusCode, message }
      const errorData = error.response.data || {};
      message = errorData.message || error.message || "An error occurred";

      // Handle specific status codes
      switch (error.response.status) {
        case 500:
          message = errorData.message || "Internal Server Error";
          break;
        case 401:
          message = errorData.message || "Invalid credentials";
          break;
        case 404:
          message = errorData.message || "Sorry! the data you are looking for could not be found";
          break;
        case 400:
          message = errorData.message || "Bad request";
          break;
        default:
          message = errorData.message || error.message || "An error occurred";
      }
      return Promise.reject(new Error(message));
    } else if (error.request) {
      // The request was made but no response was received
      message = "No response received from server";
      return Promise.reject(new Error(message));
    } else {
      // Something happened in setting up the request that triggered an Error
      return Promise.reject(new Error(error.message || "An error occurred"));
    }
  }
);


class APIClient {
  /**
   * Fetches data from given url
   */
  get(url, params, config = {}) {
    setAuthorization(); // Ensure authorization is set before each request

    let response;
    let paramKeys = [];

    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null) {
          let filterValue = params[key].toString();
          filterValue = filterValue.replace("e=>e.", "");
          paramKeys.push(key + "=" + filterValue);
        }
      });

      const queryString = paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, config);
    } else {
      response = axios.get(url, config);
    }

    return response;
  }
  /**
   * post given data to url
   */
  create(url, data) {
    setAuthorization();

    // If data is FormData, don't set Content-Type header (let browser set it with boundary)
    if (data instanceof FormData) {
      return axios.post(url, data, {
        headers: {
          'Content-Type': undefined // Let browser set the correct multipart/form-data header
        }
      });
    }

    return axios.post(url, data);
  }
  /**
   * Updates data
   */
  update(url, data) {
    setAuthorization();
    return axios.patch(url, data);
  }

  put(url, data) {
    setAuthorization();
    if (data instanceof FormData) {
      return axios.put(url, data, {
        headers: {
          'Content-Type': undefined // Let browser set the correct multipart/form-data header
        }
      });
    }
    return axios.put(url, { ...data });
  }
  /**
   * Delete
   */
  delete(url, config) {
    setAuthorization();
    if (config && typeof config === 'object') {
      return axios.delete(url, { ...config });
    }
    return axios.delete(url);
  }
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  }
  return JSON.parse(user);
};

export { APIClient, setAuthorization, getLoggedinUser };
